// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__37Xvk","inner":"Form_inner__3DDid","range":"Form_range__1_poL","name":"Form_name__JCJna","actions":"Form_actions__39l3L"};